import globalMU from "../../../globalMU"
import microuniversoApi from "../../api/microuniversoApi"
import { useAppSelector } from "../../redux/hooks"
import { IOrcamento } from "../../types/IOrcamento"
import { DadosDestinoTransferencia } from "../../types/DadosDestinoTransferencia"
import { tratamentoErroPadrao } from "../../use-cases"
import React, { useEffect, useState } from "react"
import store from "app/redux/store/store"
import { atualizarCamposPendentesOrcamentoEmAndamentoAction } from "app/redux/orcamentoEmAndamentoSlice"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { DestinoTransferencia } from "./DestinoTransferencia"

export const DestinoTransferenciaContainer = () => {
    const orcamento: IOrcamento = useAppSelector((store) => store.orcamento)
    const [dados, setDados] = useState<DadosDestinoTransferencia>()
    const [processando, setProcessando] = useState(false)

    const obterDados = async () => {
        try {
            globalMU.blockUI({ tryPassiveLoading: true })
            const resposta = await microuniversoApi.Orcamento.obterDadosDestinoTransferencia(orcamento.IdentificadorOrcamento)
            setDados(resposta)
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            globalMU.unblockUI()
        }
    }

    useEffect(() => {
        if (orcamento?.IdentificadorOrcamento != null) obterDados()
    }, [orcamento?.IdentificadorOrcamento])

    const aplicar = async (codigoFilialDestino: string) => {
        try {
            setProcessando(true)
            globalMU.blockUI({ tryPassiveLoading: true })
            const resposta = await microuniversoApi.Orcamento.salvarDadosFaturamentoTransferencia(
                orcamento.IdentificadorOrcamento,
                { ...dados, FilialDestinoCodigo: codigoFilialDestino }
            )
            // SalvarDadosFaturamentoTransferencia não devolve "Destinos" (só a action de obter faz
            // essa segunda consulta) — preservar a lista já carregada, senão o combobox perde as opções.
            setDados({ ...resposta, Destinos: dados?.Destinos })
            globalMU.showSuccessMessage("Dados do destino da transferência atualizados com sucesso.")
            // 482572 — snapshot de recuperação do orçamento em andamento (ver orcamentoEmAndamentoSlice.ts)
            store.dispatch(atualizarCamposPendentesOrcamentoEmAndamentoAction({ FilialDestinoCodigo: resposta.FilialDestinoCodigo }))
        } catch (e) {
            tratamentoErroPadrao(e)
        } finally {
            setProcessando(false)
            globalMU.unblockUI()
        }
    }

    const somenteLeitura = orcamento?.SomenteLeitura || (orcamento?.CodigoDAV ?? "") !== ""

    return <>
        <Breadcrumb2Container
            passos={["Destino da Transferência"]}
            id="DestinoTransferenciaContainer_"
            exibirBotaoLimpar={false}
            exibirBotaoVoltar={false}
        />
        {dados == null
            ? <span>Carregando... Aguarde!</span>
            : <DestinoTransferencia
                dados={dados}
                somenteLeitura={somenteLeitura}
                processando={processando}
                onAplicar={aplicar}
            />
        }
    </>
}
